import React from 'react';
import LocalPostOffice from '@material-ui/icons/LocalPostOffice';
import Assessment from '@material-ui/icons/Assessment';
import PeopleIcon from '@material-ui/icons/People';
import ListAlt from '@material-ui/icons/ListAlt';
import GroupAdd from '@material-ui/icons/GroupAdd';
import Settings from '@material-ui/icons/Settings';
import Security from '@material-ui/icons/Security';

import {
    BorderAll,
    DonutSmall,
    ImportContacts,
    LocalShipping,
    PhoneCallback,
    Receipt,
    Place
} from '@material-ui/icons';

const CustomIcon = ({ icon }: { icon?: string | undefined }) => {
    switch (icon) {
        case 'GroupAdd':
            return <GroupAdd />;
        case 'LocalPostOffice':
            return <LocalPostOffice />;
        case 'Assessment':
            return <Assessment />;
        case 'ImportContacts':
            return <ImportContacts />;
        case 'Receipt':
            return <Receipt />;
        case 'PeopleIcon':
            return <PeopleIcon />;
        case 'ListAlt':
            return <ListAlt />;
        case 'Settings':
            return <Settings />;
        case 'LocalShipping':
            return <LocalShipping />;
        case 'DonutSmall':
            return <DonutSmall />;
        case 'BorderAll':
            return <BorderAll />;
        case 'PhoneCallback':
            return <PhoneCallback />;
        case 'Place':
            return <Place />;
        case 'PlacePurple':
            return <Place  style={{ color: '#62029e', fontSize: '28px' }}/>;
        case 'Security':
            return <Security />;
        default:
            return null;
    }
};

export default CustomIcon;
